/**
 * Move the cursor to the end of a contenteditable element's content.
 *
 * @param {HTMLElement} el - The contenteditable element to place the cursor in.
 */
export function placeCursorAtEnd(el) {
  const range = document.createRange();
  range.selectNodeContents(el);
  range.collapse(false);

  const sel = window.getSelection();
  sel.removeAllRanges();
  sel.addRange(range);
}

/**
 * Insert a DOM node at the current cursor position within a contenteditable element.
 * Falls back to appending to `fallbackEl` if there is no active selection.
 *
 * @param {Node} node - The DOM node to insert.
 * @param {HTMLElement} fallbackEl - Element to append to when there is no selection.
 */
export function insertNodeAtCursor(node, fallbackEl) {
  const sel = window.getSelection();
  if (sel && sel.rangeCount) {
    const range = sel.getRangeAt(0);
    range.deleteContents();
    range.insertNode(node);
    range.setStartAfter(node);
    range.collapse(true);
    sel.removeAllRanges();
    sel.addRange(range);
  } else {
    fallbackEl.appendChild(node);
  }
}
